import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-with-large-text-right.component.scss';
var ImageWithLargeTextRight = /** @class */ (function (_super) {
    tslib_1.__extends(ImageWithLargeTextRight, _super);
    function ImageWithLargeTextRight(element) {
        return _super.call(this, element) || this;
    }
    ImageWithLargeTextRight.prototype.init = function () {
    };
    ImageWithLargeTextRight.prototype.bindEvents = function () {
    };
    return ImageWithLargeTextRight;
}(Base));
export { ImageWithLargeTextRight };



//////////////////
// WEBPACK FOOTER
// ./components/image-with-large-text-right/image-with-large-text-right.component.ts
// module id = 377
// module chunks = 0